import { PropTypes } from 'prop-types';
import React, { memo } from 'react';

const CloseIcon = ({ size = 20, fill = '#696F88' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      data-testid="close-icon"
      className="fill-current"
    >
      <path
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill={fill}
      />
    </svg>
  );
};

CloseIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.number
};

export default memo(CloseIcon);
